module.exports = __webpack_public_path__ + "fonts/Outfit-Medium.3c88ad79.ttf";